export default __webpack_public_path__ + "289897cc12d2643b2da6f543f4369d08.png";